module.exports = __webpack_public_path__ + "img/success_9.ce3d0319.gif";